import React, { memo } from 'react';

import { useModal } from '../../../../../../../hooks/use-modal';
import { EditRecipientTaxIdentifiersModal } from '../edit-tax-identifiers';
import { ReadOnlyRecipientTaxIdentifiersContent } from './read-only-tax-identifiers-content';

/**
 * @param {object} props
 * @param {string} props.fulfillmentPlanId - selected fulfillmentPlanId to show tax identifier value
 * @returns {JSX.Element} The rendered ReadOnlyRecipientTaxIdentifiers
 */
export const ReadOnlyRecipientTaxIdentifiers = memo(({ fulfillmentPlanId }) => {
  const { open, close, isOpen } = useModal();

  return (
    <>
      <ReadOnlyRecipientTaxIdentifiersContent fulfillmentPlanId={fulfillmentPlanId} onEdit={open} />
      {isOpen ? <EditRecipientTaxIdentifiersModal onClose={close} /> : null}
    </>
  );
});
